var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFilterSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9.936,
    viewBox: "0 0 14 9.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53054",
    "data-name": "Path 53054",
    d: "M4.53,0A2.343,2.343,0,0,0,2.252,1.818H.538a.54.54,0,0,0,0,1.081H2.252a2.338,2.338,0,0,0,4.555,0h6.655a.54.54,0,0,0,0-1.081H6.807A2.343,2.343,0,0,0,4.53,0Zm0,3.637A1.272,1.272,0,1,1,5.795,2.365,1.268,1.268,0,0,1,4.53,3.637Z",
    transform: "translate(0)",
    fill: "#85888a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53055",
    "data-name": "Path 53055",
    d: "M9.489,8.3a2.343,2.343,0,0,0-2.277,1.818H.538a.54.54,0,0,0,0,1.081H7.193a2.338,2.338,0,0,0,4.555,0h1.714a.54.54,0,0,0,0-1.081H11.748A2.343,2.343,0,0,0,9.489,8.3Zm0,3.624a1.272,1.272,0,1,1,1.265-1.272A1.268,1.268,0,0,1,9.489,11.924Z",
    transform: "translate(0 -3.073)",
    fill: "#85888a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterSm);
export default __webpack_public_path__ + "static/media/icon-filter-sm.ac35c3e7.svg";
export { ForwardRef as ReactComponent };